"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeCsvLlmAction = exports.nativeCsvLlmActionResultSchema = exports.nativeCsvLlmActionArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
var nativeCsvReader_1 = require("./nativeCsvReader");
// Argument schema
exports.nativeCsvLlmActionArgsSchema = zod_1.z.object({
    data: zod_1.z
        .array(nativeCsvReader_1.CsvDataRowSchema)
        .describe('The CSV data to process. Array of CsvDataRow objects, one for each row in the CSV.'),
    prompt: zod_1.z.string().describe("\nPrompt to modify, filter, or transform the CSV rows. \n- Make sure to be specific for filtering requests, e.g. use working like starts with, ends with, contains, equal to etc.\n- Be detailed on which columns to look at, e.g. \"Email\" or \"Email, Status\", etc.\n- Be specific on if a row should be filtered or deleted.\n"),
    model: zod_1.z
        .enum([
        'gpt-5-mini',
        'gpt-5',
        'o4-mini',
        'gpt-5-nano',
        'gpt-4o-mini',
        'gpt-4o',
        'gpt-4.1',
        'gpt-4.1-mini',
    ])
        .describe('LLM to use for actioning on this row. For simple tasks such as data trimming, column removal etc, use gpt-5-mini. Else use gpt-5.'),
    emitMode: zod_1.z.literal(common_1.emitModeSchema.enum.single),
    batchSize: zod_1.z
        .enum(['5', '10', '25'])
        .default('10')
        .describe('Number of rows to process in a batch. Default to 10.'),
});
// Result schema - returns array of CsvDataRow objects to preserve structure
exports.nativeCsvLlmActionResultSchema = zod_1.z.object({
    results: zod_1.z
        .array(nativeCsvReader_1.CsvDataRowSchema)
        .describe('The processed CSV data. Array of CsvDataRow objects, one for each row in the CSV.'),
});
// Tool definition
exports.nativeCsvLlmAction = (0, common_1.createToolMetadata)({
    id: 'nativeCsvLlmAction',
    displayName: 'CSV LLM Action',
    displayDescription: 'Perform scalable LLM actions on CSV data rows while preserving structure',
    category: 'ai',
    color: common_1.BRAND_COLORS.AI,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.AI),
    icon: 'ai-csv',
    argsSchema: exports.nativeCsvLlmActionArgsSchema,
}, exports.nativeCsvLlmActionResultSchema);
